import React, { useState } from "react";
function Backdrop(props) {
  return (
    <div
      className={`  fixed bg-black  top-0 flex  flex-col  justify-center
     bottom-0 right-0  z-50  overflow-y-scroll  h-full w-full bg-opacity-30`}
    >
      {props.children}
    </div>
  );
}

export default Backdrop;
